import * as React from "react";
import classNames from "classnames";

interface IProps {
    height?: number;
    width?: number;
    mainColor?: string;
    accentColor?: string;
    className?: string;
}

export const AdditionalAreaIcon = (props: IProps) => {
    return (
        <svg className={classNames(props.className, "svg-icon")} width={props.width || "10.58mm"} height={props.height || "10.58mm"} viewBox="0 0 30 30">
            <path d="M1,9.89a1,1,0,0,0,1-1V2H8.9a1,1,0,0,0,1-1,1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V8.9A1,1,0,0,0,1,9.89Z" fill={props.mainColor || "#37474f"} />
            <path d="M8.9,28H2V21.1a1,1,0,0,0-1-1,1,1,0,0,0-1,1V29a1,1,0,0,0,1,1H8.9a1,1,0,0,0,0-2Z" fill={props.mainColor || "#37474f"} />
            <path d="M29,20.11a1,1,0,0,0-1,1V28H21.1a1,1,0,1,0,0,2H29a1,1,0,0,0,1-1V21.1A1,1,0,0,0,29,20.11Z" fill={props.mainColor || "#37474f"} />
            <path d="M29,0H21.1a1,1,0,0,0-1,1,1,1,0,0,0,1,1H28V8.9a1,1,0,1,0,2,0V1A1,1,0,0,0,29,0Z" fill={props.mainColor || "#37474f"} />
            <path d="M23.94,16a1,1,0,0,0,0-2H16V6.06a1,1,0,0,0-2,0v8H6.06a1,1,0,1,0,0,2h8v8a1,1,0,1,0,2,0V16Z" fill={props.accentColor || "#8b6aac"} />
        </svg>
    );
};
